define([
	"dojo/_base/lang",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
	"dojo/text!csi/templates/pageSize.html",
	"csi/widget/FilteringSelect"
], function(lang, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, Action, PluginFactory, ToolbarPlugin, template) {

	return PluginFactory.declare("pageSize", [_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, ToolbarPlugin], {
		templateString: template,
		_sizeNode: null,

		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ViewPageSize"
			});
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: forward disabled status to select widget
			this._setDisabled(this._sizeNode, !ctx || ctx.view.get("querySizeDisabled"));
		},

		postCreate: function() {
			// summary: set initial value
			var view = this.getView();
			this.inherited(arguments);
			this._sizeNode.set("store", view.querySizeStore);
			this._onWatchValue(null, null, view.get("querySize"));
			view.watch("querySize", lang.hitch(this, this._onWatchValue));
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide plugin if result size in view is fixed
			return ctx.view.relRoot && !ctx.view.get("querySizeFixed");
		},

		_onChangeSize: function(/*Object*/value) {
			// summary: invoke action to set page size if the value exists
			var n = Number(value);
			if (!isNaN(n) && (value != "")) {
				this.onChange({querySize: n});
			}
		},

		_onWatchValue: function(/*String*/name, /*Any*/oldValue, /*Any*/newValue) {
			// summary: update value without triggering onChange event
			this._sizeNode.reinitializeValue(String(newValue));
		}
	});
});